import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SkillTreeService } from './skill-tree.service';

@Component({
  selector: 'app-skill-tree-by-course',
  templateUrl: './skill-tree-by-course.component.html',
  styleUrls: ['./skill-tree-by-course.component.scss']
})
export class SkillTreeByCourseComponent implements OnInit {
  allSkillTree = [];

  constructor(
    private skillTreeService: SkillTreeService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.skillTreeService.getSkillTreeByCourse(this.route.snapshot.queryParams.course_id).subscribe(res => {
      this.allSkillTree = [...new Set(res.result)];
    })
  }

}
